<template>
    <button
        type="button"
        role="switch"
        class="toggle-switch"
        :class="{ 'toggle-switch--active': value }"
        :aria-checked="value ? 'true' : 'false'"
        :aria-label="label"
        :disabled="disabled"
        @click="$emit('input', !value)"
    >
        <span class="toggle-switch__knob"></span>
    </button>
</template>

<script>
export default {
    name: 'ToggleSwitch',
    props: {
        value: { type: Boolean, default: false },
        label: { type: String, default: '' },
        disabled: { type: Boolean, default: false }
    }
}
</script>

<style lang="scss" scoped>
.toggle-switch {
    position: relative;
    flex-shrink: 0;
    width: 32px;
    height: 18px;
    padding: 0;
    border: none;
    @include border-radius(9px);
    background-color: $color-neutral-400;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &__knob {
        position: absolute;
        top: 3px;
        left: 3px;
        width: 12px;
        height: 12px;
        @include border-radius(100%);
        background-color: $color-white;
        transition: transform 0.2s ease;
    }

    &--active {
        background-color: $main;

        .toggle-switch__knob {
            transform: translateX(14px);
        }
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
}
</style>
